import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCTA.css';

interface ServiceCTAProps {
  heading: string;
  subheading?: string;
  primaryText: string;
  primaryTo: string;
  phone?: string;
}

export const ServiceCTA: React.FC<ServiceCTAProps> = ({
  heading,
  subheading,
  primaryText,
  primaryTo,
  phone = '(786) 628-3731',
}) => (
  <section className="rn-scta">
    <div className="rn-scta__inner">
      <h2 className="rn-scta__heading">{heading}</h2>
      {subheading && <p className="rn-scta__sub">{subheading}</p>}
      <div className="rn-scta__actions">
        <Link to={primaryTo} className="cs-button-solid">{primaryText}</Link>
        <a href={`tel:${phone.replace(/\D/g, '')}`} className="rn-scta__phone">
          or call {phone}
        </a>
      </div>
    </div>
  </section>
);
